/**
 * HGW Industry brand symbol — 2x2 rounded squares grid.
 * Inline SVG so it can be recoloured via CSS `color` or `fill`.
 * Default fill uses currentColor; pass `bg` to add a filled square background.
 */
export default function HGWSymbol({ size = 24, className = "", bg = null, ...props }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {bg && <rect width="100" height="100" rx="18" fill={bg} />}
      <g fill="currentColor">
        {/* 2x2 rounded outlined squares, symbol occupies ~70% centred */}
        {/* symbol geometry (inside a 100x100 viewbox) */}
        {(() => {
          const symbolSide = 70;
          const offset = (100 - symbolSide) / 2; // 15
          const gap = symbolSide * 0.09; // 6.3
          const tile = (symbolSide - gap) / 2; // 31.85
          const outerR = tile * 0.22;
          const strokeW = tile * 0.19;
          const innerR = Math.max(0.5, outerR - strokeW / 2);
          const tiles = [];
          for (let row = 0; row < 2; row++) {
            for (let col = 0; col < 2; col++) {
              const x0 = offset + col * (tile + gap);
              const y0 = offset + row * (tile + gap);
              tiles.push(
                <path
                  key={`${row}-${col}`}
                  d={makeRing(x0, y0, tile, outerR, strokeW, innerR)}
                  fillRule="evenodd"
                />
              );
            }
          }
          return tiles;
        })()}
      </g>
    </svg>
  );
}

/** Build a path with an outer rounded rect and an inner rounded rect hole (evenodd fill). */
function makeRing(x, y, size, outerR, strokeW, innerR) {
  const outer = roundRectPath(x, y, size, size, outerR);
  const inner = roundRectPath(x + strokeW, y + strokeW, size - 2 * strokeW, size - 2 * strokeW, innerR);
  return `${outer} ${inner}`;
}

function roundRectPath(x, y, w, h, r) {
  r = Math.min(r, w / 2, h / 2);
  return (
    `M ${x + r} ${y} ` +
    `H ${x + w - r} ` +
    `Q ${x + w} ${y}, ${x + w} ${y + r} ` +
    `V ${y + h - r} ` +
    `Q ${x + w} ${y + h}, ${x + w - r} ${y + h} ` +
    `H ${x + r} ` +
    `Q ${x} ${y + h}, ${x} ${y + h - r} ` +
    `V ${y + r} ` +
    `Q ${x} ${y}, ${x + r} ${y} ` +
    `Z`
  );
}
